import React from "react";
import Dashboard from "../Images/Dashboard2.png";
import Header from "../components/Header";
import { Zoom } from "react-reveal";
import HomeText from "../components/HomeText";
import Backgroung from "../Images/Backgroung.png";
import BackgroundHome from "../Images/BackgroundImgPackersHome.jpg";
import HomeMobile from "../Images/HomeMobile.jpg";
import Section2 from "../Screen/Section2";
import Ourclient from "../Screen/Ourclient";
import Ourservice from "../Screen/Ourservice";
import EuctoPartner from "../Screen/EuctoPartner";
import Howweword from "../Screen/Howweword";
import Faq from "../Screen/Faq";
import Footer from "../Screen/Footer";
import { useNavigate } from "react-router-dom";
import WatchVideo from "../components/WatchVideo";
import CookieConsent from "../components/Cookies";
import "./Home.css";

const Home = () => {
  const navigate = useNavigate();

  const handleGetStart = () => {
    sessionStorage.setItem("selectedService", "Movers");
    sessionStorage.setItem("selectedSubService", "");
    sessionStorage.setItem("serviceid", 2);
    navigate("/finalform");
  };

  return (
    <div>
      <CookieConsent />
      {/* className='mainBanner' */}
      <Header />
     
<div className="heroBanner">
  <div className="bannerImageWrapper">
    <img
      src={BackgroundHome}         // desktop image by default
      alt="Banner"
      className="bannerImg"
    />
    <div className="bannerOverlay">
      <h2 className="heroTitle">
        <span style={{ color: "#000000" }}>Convert Leads With </span>
        <span style={{ color: "#2762B1" }}>Blaccdot</span>
        <span style={{ color: "#2762B1", display: "block" }}>
          Lead Management System
        </span>
      </h2>

      <div className="cta-wrapper" onClick={handleGetStart}>
        <button className="cta-cut-btn">
          <span className="text">Get Started Now</span>
        </button>
        <span className="cta-arrows">
          <span></span>
          <span></span>
        </span>
      </div>
    </div>
  </div>
</div>

{/* Section2 now naturally comes below the heroBanner */}
<div><Section2 /></div>
      <div>
        <WatchVideo />
      </div>
      <div>
        <Ourservice id="service" />
      </div>
      {/* <div className='my-5'>
      <Ourclient/>
    </div> */}
      <div className="mb-5">
        <EuctoPartner />
      </div>
      <div className="hidden-me-Howweword">
        <Howweword />
      </div>
      <div className="pt-5">
        <Faq />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <a
          href="/selectservices"
          class="btnGetQuote"
          style={{
            padding: "23px",
            position: "fixed",
            zIndex: "9999",
            right: "20px",
            bottom: "20px",
            width: "100px",
            height: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h5
            style={{
              fontFamily: "Lato,sans-serif",
              fontWeight: "600",
              margin: 0,
            }}
          >
            GET <br />
            QUOTE
          </h5>
        </a>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
